"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var AffilatePayoutEditor = /** @class */ (function (_super) {
    __extends(AffilatePayoutEditor, _super);
    function AffilatePayoutEditor(props) {
        return _super.call(this, props) || this;
    }
    AffilatePayoutEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_payout_id: _item.app_payout_id,
                    app_payout_title: _item.app_payout_title,
                    is_deprecated: _item.is_deprecated
                });
            }
        }
        else {
            this.setState({
                app_payout_id: 0,
                app_payout_title: "",
                is_deprecated: false
            });
        }
        this.doReSetRules();
    };
    AffilatePayoutEditor.prototype.doReSetRules = function () {
        this.setState({
            app_payout_rules: { isError: false }
        });
    };
    AffilatePayoutEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_payout_id <= 0) || (this.state.app_payout_title.length === 0)) {
            this.setState({ app_payout_rules: { isError: true, errorMessage: "Тип выплаты не выбран!" } });
            return false;
        }
        return true;
    };
    /*private OnUpdateDataClick() {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_payout_id: this.state.app_payout_id,
                is_deprecated: this.state.is_deprecated,
            }, () => {
                notificationHelper.ShowTextTopRightInfoNotify("Тип выплаты партнерской программы изменен!");
            })
        }
    }*/
    AffilatePayoutEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                pprogram_id: this.props.rootRecord.key,
                app_payout_id: this.state.app_payout_id,
                is_deprecated: this.state.is_deprecated
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Тип выплаты партнерской программы добавлен!");
            });
        }
    };
    AffilatePayoutEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AffilatePayoutEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый тип выплаты партнерской программы";
        }
        else {
            return "Изменить тип выплаты партнерской программы";
        }
    };
    AffilatePayoutEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 320 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип выплаты:", placeholder: "Выберите тип выплаты" }, value: { key: this.state.app_payout_id, value: this.state.app_payout_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_payout_id: newVal.key,
                        app_payout_title: newVal.value,
                        app_payout_rules: { isError: false }
                    });
                }, items: this.props.availPayouts, required: true, rules: this.state.app_payout_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Тип выплаты устарел", value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { /*btnEdit: "Сохранить",*/ btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return AffilatePayoutEditor;
}(React.Component));
exports.default = AffilatePayoutEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/payout/AffilatePayoutEditor.tsx
// module id = 2025
// module chunks = 0